var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmartPorts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M8.4 14.7c-.3 0-.5-.2-.5-.5v-3.4c0-.3.2-.5.5-.5s.5.2.5.5v3.4c0 .3-.3.5-.5.5M4.4 14.7c-.3 0-.5-.2-.5-.5v-3.4c0-.3.2-.5.5-.5s.5.2.5.5v3.4c0 .3-.2.5-.5.5M8.3 7.6h-.1c-.2-.1-.4-.4-.3-.7l.8-3.3c0-.2.3-.4.5-.3.3.1.4.3.4.6l-.8 3.3c0 .2-.2.4-.5.4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M16.6 9.6c-.3 0-.5-.2-.5-.5L16 4.3H7.8l-.7 2.8c-.1.3-.4.4-.6.4-.3-.1-.5-.4-.4-.6l1-3.6h10l.1 5.8c-.1.3-.3.5-.6.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M19.9 11.8h-6.3V8.6h6.3zm-5.4-1h4.3V9.6h-4.3z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M16.3 16.5c-.3 0-.5-.2-.5-.5v-2.8h6.3v2.4c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-1.4h-4.3V16c0 .3-.2.5-.5.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M23.8 22.7H4.1L.7 15.5c-.2-.4-.2-.8 0-1.1.2-.4.6-.6 1-.6h9.9l1.5 1.7H24c.4 0 .8.2 1 .5s.3.8.2 1.2zm-19-1h18.3l1.3-4.8v-.3s-.1-.1-.2-.1H12.8l-1.5-1.7H1.8c-.1 0-.1.1-.1.1v.2zM9.7 11.2H3.1l.8-4.7h5zm-5.4-1h4.2l-.4-2.7H4.7z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M6.9 8h1.8v1H6.9z"
})));
export default SvgSmartPorts;